module.exports = __webpack_public_path__ + "static/media/japanese-speaking-training.e4a0d9db.jpg";